import React from 'react';
import './style.css'

const NotAvailable = () => {
	return(
		<div class="notAvailableContainer">
			<h1>Sorry We Are Not Currently Available In This City</h1>
			<br></br>
			<h1> <span class="ascii">(╯°□°）╯︵ ┻━┻</span></h1>
		</div>
	)
}

export default NotAvailable;